<div id="content-section">
    <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
        <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
            <div class="sticky-top">
                <small class="bg-white">
                  <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
                    <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
                  </a>
                </small>
            </div>
            <div class="text-center pagination-small-margin pagination-center">
                <pagination
                    (pageChanged)="search($event, null)"
                    class="pagination-sm"
                    [boundaryLinks]="true"
                    [totalItems]="count"
                    [maxSize]="5"
                    [itemsPerPage]="searchParams.per_page"
                    [(ngModel)]="searchParams.page"
                    previousText="&lsaquo;"
                    nextText="&rsaquo;"
                    firstText="&laquo;"
                    lastText="&raquo;"
                ></pagination>
            </div>
            <div class="text-center pt-1">
                <app-pagination-count
                    [count]="count"
                    singularName="Factor"
                    pluralName="Factors"
                ></app-pagination-count>
            </div>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="sticky-top bg-white">
                <h5 class="pt-2">
                <div class="pull-right float-right">
                    <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
                </div>
                <span>
                    Search&nbsp;&nbsp;
                    <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search(null, true) : ''">
                        <i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i>
                    </a>
                </span>
                </h5>
                <hr class="my-1" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <form>
                        <div class="form-group">
                            <label for="attorney">Attorney:</label>
                            <select class="form-control" id="attorney" [(ngModel)]="searchParams['attorney_id']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="attorney.id" *ngFor="let attorney of searchOptions.attorneys">{{attorney.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="allocation-type">Allocation Type:</label>
                            <select class="form-control" id="allocation-type" [(ngModel)]="searchParams['search[allocation_type_id]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="allocation_type.id" *ngFor="let allocation_type of searchOptions.allocation_types">{{allocation_type.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="matter-name">Matter Name/Number:</label>
                            <app-matter-search id="matter-name" [placeholder]="'Search and select'" (clearMatter)="searchParams['search[matter_id]'] = undefined" [matterId]="searchParams['search[matter_id]']" [small_input]="false" (matter_id)="searchParams['search[matter_id]']=$event"></app-matter-search>
                        </div>
                        <div class="form-group">
                            <label for="matter-type">Matter Type:</label>
                            <select class="form-control" id="matter-type" [(ngModel)]="searchParams['search[matter_type_id][]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="matterType.id" *ngFor="let matterType of searchOptions.matter_types">{{matterType.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="contact-name">Client Name:</label>
                            <app-contact-search id="contact-name" [contactId]="searchParams['contact_id']" (clearContact)="searchParams['contact_id'] = undefined" [placeholder]="'Search and select'" [small_input]="false" (contact_id)="searchParams['contact_id']=$event"></app-contact-search>
                        </div>
                        <div class="form-group">
                            <label for="amount">Amount:</label>
                            <input class="form-control" type="text" id="amount" name="amount" [(ngModel)]="searchParams['search[amount]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-group">
                            <label for="entry-group">Entry Group:</label>
                            <input class="form-control" type="number" id="entry-group" name="entry-group" [(ngModel)]="searchParams.entry_group_ids" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="from-date">Date From:</label>
                                <input type="text" class="form-control" #FilterFromDate="ngModel" name="from-date" [(ngModel)]="searchParams['search[date_from]']" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams['search[date_from]'] = $event" id="fromDate" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="to-date">Date To:</label>
                                <input type="text" class="form-control" #FilterToDate="ngModel" name="to-date" [(ngModel)]="searchParams['search[date_to]']" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams['search[date_to]'] = $event" id="toDate" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="order-by">Order By:</label>
                                <select class="form-control" id="order-by" [(ngModel)]="searchParams.order_by" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                    <option value=""></option>
                                    <option *ngFor='let orderBy of searchOptions.order_by' [value]='orderBy.value'>{{orderBy.label}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="in-order-of">In Order Of:</label>
                                <select class="form-control" id="in-order-of" [(ngModel)]="searchParams.order_direction" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                    <option value=""></option>
                                    <option *ngFor='let orderDirection of searchOptions.order_direction' [value]='orderDirection.value'>{{orderDirection.label}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'all'">
                                <input [checked]="searchParams.reversal == 'all'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">All</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'hide_reversed'">
                                <input [checked]="searchParams.reversal == 'hide_reversed'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">Hide Reversed</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'only_reversed'">
                                <input [checked]="searchParams.reversal == 'only_reversed'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">Only Reversed</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <app-search-btn [searching]="searching" (onClick)="searchParams.page = 1; search(null, true)"></app-search-btn>
                        </div>
                    </form>
                    <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                        <table class="table" style="transform: rotateX(180deg);">
                            <thead>
                                <tr>
                                    <th colspan="2">Allocation Type Totals</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                               <tr *ngFor="let allocation of allocations">
                                    <th></th>
                                    <td>{{allocation.name}}</td>
                                    <td class="text-right">
                                        <span *ngIf="allocation.amount">{{allocation.amount | currency: 'USD':'symbol':'1.2-2'}}</span>
                                        <span *ngIf="!allocation.amount"></span>
                                    </td>
                               </tr>
                                <tr>
                                    <th>
                                       All
                                    </th>
                                    <td></td>
                                    <th class="text-right">
                                        <span *ngIf="total">{{total | currency: 'USD':'symbol':'1.2-2'}}</span>
                                        <span *ngIf="!total"></span>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
            <div class="container-shadow px-3 pb-4">
                <h2 class="pt-4 text-center">Factors</h2>
                <hr class="mt-1 mb-2" />
                <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                    <table class="table" style="transform: rotateX(180deg);">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Group</th>
                                <th>Matter</th>
                                <th>Description</th>
                                <th>Date</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let factor of factors">
                                <td><a [href]="'/factors/' + factor.id">{{factor.id}}</a>&nbsp;&nbsp;<a [href]="factor.tree_link_path"><i class="fas fa-tree"></i></a></td>
                                <td><a [href]="'/entry_groups/' + factor.entry_group_id">{{factor.entry_group_id}}</a></td>
                                <td><a [routerLink]="'/matters/' + factor.matter_id">{{factor.matter.number}}</a></td>
                                <td>
                                    <a [routerLink]="'/persons/' + factor.contact_id">{{factor.contact.display_name}}</a> {{factor.allocation_type.name}}<br>
                                    <span [innerHTML]="factor.description | safeHtml"></span><br>
                                    <span class="lightsalmon" *ngIf="factor.is_reversed">Reversed By: <a [routerLink]="[]">{{factor.reverse_entry_id}}</a></span>
                                    <span class="lightsalmon" *ngIf="factor.is_reversal">Reverses: <a [routerLink]="[]">{{factor.reverses_id}}</a></span>
                                </td>
                                <td>{{factor.date}}</td>
                                <td class="text-right">
                                    <span *ngIf="factor.amount">{{factor.amount | currency: 'USD':'symbol':'1.2-2'}}</span>
                                    <span *ngIf="!factor.amount"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>
